export default __webpack_public_path__ + "static/media/violin1.adaf2c60.mp3";